import React from 'react'
import AddNewCourseForm from '../../../components/AddCoursesStepForm/AddCoursesStepForm'
export default function InstructorAddCourses() {
  return (
    <AddNewCourseForm />
  )
}
